import { BehaviorSubject } from "rxjs";
import cleaner from "./propCleaner";
import attachRefs from "./attachRefs";
import methods from "./methods";
const builder = (model = {}, key, schema = {}, props = {}) => {
  model.modelName = key;
  model.isNew = true; // used to identify that this model has been built and not updated
  model._subjects = new BehaviorSubject();
  model._subjects.next(cleaner(schema, props));
  model.update = (props = {}) => {
    model.isNew = false;
    model._subjects.next(cleaner(schema, props));
  };
  model.observable = () => model._subjects.asObservable();
  model.data = (excludeRefs = false) => {
    // return model._subjects.getValue()
    const data = model._subjects.getValue();
    if (!excludeRefs) {
      Object.keys(model._refs).forEach((key) => {
        if (model[key] instanceof Array) {
          data[`_${key}`] = model[key].map((model) => model.data(true));
          return;
        }
        if (!model[key]) return;
        data[`_${key}`] = model[key]?.data(true);
      });
    }
    return data;
    return { ...model._subjects.getValue(), ...refs };
  };
  model.toJSON = () => {
    return model.data(true);
  };
  if (methods[key]) methods[key](model);
  attachRefs(schema, model);
};
export default builder;
